import { render, staticRenderFns } from "./FullScreenCloseVisit.vue?vue&type=template&id=1a4a74e2&scoped=true&"
import script from "./FullScreenCloseVisit.vue?vue&type=script&lang=js&"
export * from "./FullScreenCloseVisit.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenCloseVisit.vue?vue&type=style&index=0&id=1a4a74e2&prod&lang=scss&"
import style1 from "./FullScreenCloseVisit.vue?vue&type=style&index=1&id=1a4a74e2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4a74e2",
  null
  
)

export default component.exports